var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2B74D8",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8173 17.5448L18.4198 11.9423L17.5417 11.0642L12.8173 15.7886L10.4423 13.4136L9.56418 14.2917L12.8173 17.5448ZM14.0015 21.9167C12.9065 21.9167 11.8772 21.7089 10.9138 21.2933C9.95029 20.8778 9.11223 20.3138 8.39959 19.6015C7.68695 18.8891 7.12272 18.0514 6.70688 17.0883C6.29119 16.1253 6.08334 15.0963 6.08334 14.0015C6.08334 12.9065 6.29112 11.8772 6.70668 10.9138C7.12223 9.95029 7.68619 9.11223 8.39855 8.39959C9.11091 7.68695 9.94862 7.12272 10.9117 6.70688C11.8747 6.29119 12.9037 6.08334 13.9986 6.08334C15.0936 6.08334 16.1228 6.29112 17.0863 6.70668C18.0497 7.12223 18.8878 7.68619 19.6004 8.39855C20.3131 9.11091 20.8773 9.94862 21.2931 10.9117C21.7088 11.8747 21.9167 12.9037 21.9167 13.9986C21.9167 15.0936 21.7089 16.1228 21.2933 17.0863C20.8778 18.0497 20.3138 18.8878 19.6015 19.6004C18.8891 20.3131 18.0514 20.8773 17.0883 21.2931C16.1253 21.7088 15.0963 21.9167 14.0015 21.9167ZM14 20.6667C15.8611 20.6667 17.4375 20.0208 18.7292 18.7292C20.0208 17.4375 20.6667 15.8611 20.6667 14C20.6667 12.1389 20.0208 10.5625 18.7292 9.27084C17.4375 7.97918 15.8611 7.33334 14 7.33334C12.1389 7.33334 10.5625 7.97918 9.27084 9.27084C7.97918 10.5625 7.33334 12.1389 7.33334 14C7.33334 15.8611 7.97918 17.4375 9.27084 18.7292C10.5625 20.0208 12.1389 20.6667 14 20.6667Z",
    fill: "#2B74D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverCharge);
export default __webpack_public_path__ + "static/media/cover-charge.679eabc0c55e9f22ac0c09dc6364c16d.svg";
export { ForwardRef as ReactComponent };